import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.ADMINISTRATORS.INVITE,
  payload,
})
